import React from 'react';
import styled from 'styled-components';
import { MdDeleteForever } from 'react-icons/md';
import { Flex, Text, Box, Button } from '../design-system';
import { displayText, formatTime, renderMultilineText } from '../helpers/utils';
import Tooltip from './Tooltip';

const UnstyledButton = styled(Button)`
  font-size: 100%;
  font-family: inherit;
  border: 0;
  padding: 0;
  cursor: pointer;
`;

interface NotesTooltipProps {
  row: {
    original: {
      handleDeleteNote: (id: any) => void;
      project_notes?: any[];
      client_notes?: any[];
    };
  };
}

const NotesTooltip = ({
  row: {
    original: { handleDeleteNote, project_notes, client_notes },
  },
}: NotesTooltipProps) => {
  const notes = project_notes || client_notes;
  if (notes) {
    return (
      <Flex flexDirection="column" justifyContent="center">
        {notes.map(({ id, note, created_at, creator }) => {
          const { text, more } = displayText(note);
          return (
            <Flex key={id} alignItems="center">
              <Box maxWidth={300}>
                <Text fontSize={12}>
                  {creator.name} {formatTime(created_at)}
                  <span> : </span>
                  {renderMultilineText(text)}
                  {more && <Tooltip text={note}>...</Tooltip>}
                </Text>
              </Box>
              <Box>
                <UnstyledButton
                  ml={1}
                  type="button"
                  title="Remove Note"
                  aria-label="Remove Note"
                  variant="primaryText"
                  onClick={() => handleDeleteNote(id)}
                >
                  <MdDeleteForever fontSize={18} />
                </UnstyledButton>
              </Box>
            </Flex>
          );
        })}
      </Flex>
    );
  }
  return null;
};

export default NotesTooltip;
